import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { GENERAL_FRAGMENT } from './fragments/general'
import { PREBID_STACK_FRAGMENT } from './fragments/prebidStack'
import { REFRESHER_FRAGMENT } from './fragments/refresher'
import { UNFILLED_RECOVERY_FRAGMENT } from './fragments/unfilledRecovery'
import { VIEWABILITY_TOOLS_FRAGMENT } from './fragments/viewabilityTools'

import type { Data } from './types'

export const GET_AB_TEST_PARAMETERS_SCHEMA: TypedDocumentNode<Data> = gql`
  ${GENERAL_FRAGMENT}
  ${PREBID_STACK_FRAGMENT}
  ${REFRESHER_FRAGMENT}
  ${UNFILLED_RECOVERY_FRAGMENT}
  ${VIEWABILITY_TOOLS_FRAGMENT}

  query abTestParametersSchema($domainId: ID!) {
    abTestParametersSchema(domainId: $domainId) {
      general {
        ...generalFragment
      }
      prebidStack {
        ...prebidStackFragment
      }
      refresher {
        ...refresherFragment
      }
      unfilledRecovery {
        ...unfilledRecoveryFragment
      }
      viewabilityTools {
        ...viewabilityToolsFragment
      }
    }
  }
`
